<template>
  <div class="is-relative">
    <div v-if="loading" class="is-overlay is-flex" style="z-index: 9999; align-items: center; justify-content: center;">
      <div class="has-text-centered box is-flex" style="align-items: center;">
        <font-awesome-icon icon="circle-notch" size="2x" spin />
        <p style="margin: 0 0.25em">{{ message }}</p>
      </div>
    </div>
    <div :class="loading ? 'blur' : null"><slot /></div>
  </div>
</template>

<script>
export default {
  props: {
    loading: { type: Boolean, default: false },
    message: { type: String, default: 'Loading...' }
  }
}
</script>

<style scoped>
.blur {
  filter: blur(1px);
}
</style>
